if (!customElements.get('video-controls')) {

class VideoControls extends HTMLElement {
  constructor() {
    super();
    this.videoElement = this.querySelector('video');
    this.playButton = this.querySelector('.play-button');
    this.iframeYoutube = this.querySelector('iframe');

    if (!this.playButton) {
      return;
    }

    this.playButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      if (this.iframeYoutube) {
        const src = this.iframeYoutube.getAttribute('src');

        if (!src.includes('autoplay=1')) {
          const separator = src.includes('?') ? '&' : '?';
          this.iframeYoutube.setAttribute('src', `${src}${separator}autoplay=1`);
        }

        this.iframeYoutube.classList.add('visible');
      }

      if (this.videoElement) {
        this.videoElement.classList.add('visible');
        this.videoElement.play();
      }

      this.playButton.style.display = 'none';
    });
  }

  onVideoEnded() {
    this.playButton.style.display = 'block';
  }
}

customElements.define('video-controls', VideoControls);
}